<div class="label">
  {{ BANNER_FACT_FIND_STATE_NAMES.get(status) }}
</div>
<i *ngIf="getIcon() as icon" class="material-icons">{{ icon }}</i>
